<template>
    <b-overlay
            :show="loading"
            rounded="sm"
    >
        <b-row>
            <b-col>
                <b-card
                        title="جزئیات اسلایدر محصول"
                >
                    <b-form
                            ref="productsliderform"
                            @submit.prevent
                    >
                        <b-row>

                            <b-col
                                    class="mt-2"
                                    md="6"
                                    offset-md="3"
                            >
                                <b-row>

                                    <b-col
                                            class="image"
                                            cols="12"
                                    >
                                        <b-media class="mb-2">
                                            <template #aside>
                                                <b-avatar
                                                        ref="previewEl"
                                                        :src="Form.Image"
                                                        size="90px"
                                                        rounded
                                                        button
                                                        @click="$refs.refInputEl.click()"
                                                />
                                            </template>
                                            <input
                                                    :ref="'refInputEl'"
                                                    type="file"
                                                    class="d-none"
                                                    name="Image"
                                                    @input="imageRenderer($event)"
                                            >
                                            <b-row>
                                                <b-col md="12">
                                                    <b-form-group
                                                            label="عنوان"
                                                            label-for="Title"
                                                            class="mb-0"
                                                    >
                                                        <b-form-input
                                                                id="Title"
                                                                v-model="Form.Title"
                                                                name="Title"
                                                                autocomplete="off"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-media>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="دسته بندی"
                                            label-for="ProductCategoryId"
                                        >
                                            <product-category
                                                v-model="Form.ProductCategoryId"
                                                :multiple="false"
                                                :clearable="true"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="برند"
                                                label-for="BrandId"
                                        >
                                            <brand
                                                    v-model="Form.BrandId"
                                                    :multiple="false"
                                                    :clearable="true"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group>
                                            <label>نوع</label>
                                            <v-select
                                                v-model="Form.SortBy"
                                                :options="enums('ProductSliderSortBy')"
                                                dir="rtl"
                                                label="text"
                                                :clearable="false"
                                                :reduce="x => x.value"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="جایگاه"
                                            label-for="Position"
                                        >
                                            <v-select
                                                v-model="Form.Position"
                                                :options="enums('ProductSliderPosition')"
                                                dir="rtl"
                                                label="text"
                                                :reduce="x => x.value"
                                                :clearable="false"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="وضعیت"
                                                label-for="IsActive"
                                        >
                                            <v-select
                                                    v-model="Form.IsActive"
                                                    :options="enums('IsActive')"
                                                    dir="rtl"
                                                    label="text"
                                                    :reduce="x => x.value"
                                                    :clearable="false"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <b-form-group
                                                label="توضیحات"
                                                label-for="Description"
                                        >
                                            <div class="form-label-group">
                                                <b-form-input
                                                        id="Description"
                                                        v-model="Form.Description"
                                                        name="Description"
                                                        autocomplete="off"
                                                />
                                            </div>
                                        </b-form-group>

                                    </b-col>

                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    <b-col class="mt-1 mb-2 text-center">
                                        <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                type="submit"
                                                variant="primary"
                                                class="mr-1"
                                                @click="save"
                                        >
                                            ذخیره
                                        </b-button>
                                        <b-button
                                                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                variant="outline-secondary"
                                                @click="back"
                                        >
                                            بازگشت
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import Brand from "@/tools/brand.vue";
import ProductCategory from "@/tools/productcategory.vue";

export default {
    name: 'BlogCategoryDetails',
    components: {ProductCategory, Brand},
    data() {
        return {
            Form: {
                Id: null,
                Title: null,
                Image: null,
                Description: null,
                IsActive: true,
                Position: null,
                SortBy: 0,
                BannerId: null,
                ProductCategoryId: null,
            },
            loading: false,
        }
    },
    created() {
        if (this.$route.params.id) {
            this.Form.Id = this.$route.params.id
            this.get()
        }
    },
    methods: {
        save() {
            let url = this.$api.productslider.add
            if (this.$route.params.id) {
                url = this.$api.productslider.update
            }

            const formData = new FormData(this.$refs.productsliderform)
            formData.append('Id', this.Form.Id)
            formData.append('SortBy', this.Form.SortBy)
            formData.append('IsActive', this.Form.IsActive)

            if (this.Form.Position >= 0){
                formData.append('Position', this.Form.Position)
            }

            if (this.Form.BrandId){
                formData.append('BrandId', this.Form.BrandId)
            }

            if (this.Form.ProductCategoryId)   {
                formData.append('ProductCategoryId', this.Form.ProductCategoryId)
            }

            this.loading = true
            this.$http.post(
                url, formData,
            )
                .then(() => {
                    this.back()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        imageRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.Form.Image = fileReader.result
            }
        },
        get() {
            this.loading = true
            this.$http.post(
                this.$api.productslider.get, {
                    Id: this.Form.Id,
                },
            )
                .then(res => {
                    this.loading = false
                    this.Form = res.data
                })
        },
    },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
